/**
 * Tailwind CSS breakpoint values for use in JavaScript.
 * Must stay in sync with Tailwind's default theme breakpoints.
 */
export const SM_BREAKPOINT = 640;
export const MD_BREAKPOINT = 768;
export const LG_BREAKPOINT = 1024;
export const XL_BREAKPOINT = 1280;

/**
 * Report whether the viewport is narrower than `width`, now and on every crossing.
 *
 * An editor that draws one form inline and another in a mobile sheet must follow the
 * viewport, not the width it read when the edit started: a rotation mid-edit otherwise
 * leaves the open form hidden behind the breakpoint it no longer matches.
 *
 * @param {number} width Breakpoint in px.
 * @param {(below: boolean) => void} onChange Called once now, then on each crossing.
 * @returns {() => void} Removes the listener.
 */
export function watchViewportBelow(width, onChange) {
    // Tailwind's max-* variants stop 0.02px below the breakpoint, so the two agree.
    const query = window.matchMedia?.(`(max-width: ${width - 0.02}px)`);
    if (!query) {
        onChange(window.innerWidth < width);
        return () => {};
    }

    const handler = (event) => onChange(event.matches);
    query.addEventListener('change', handler);
    onChange(query.matches);

    return () => query.removeEventListener('change', handler);
}
